import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserSession } from '../shared/user-session';

/**
 * The Auth Guard will rely on userSession to see if user has loaded necessary data.
 * If not, then first should try to load the holistic profile data by going to the fetchUserData routing url.
 *
 * Why doing reRouting instead of having a common resolver for every secured routings? There are a few benefits by doing this way
 * 1) Fetch holistic profile is really a one time job, it better stay on a seperate component
 * 2) How to fetch holistic profile should not be a concern from each secured module
 * 3) Having a fetchUserData router can handle the deeplink better
 * 4) Avoiding adding a resolver to all sercured module routings
 */

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private userSession: UserSession, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {   
    //console.log(this.userSession.getLocalStorageItem('isMfaFlow'));   
   // this.userSession.promoPageTaken = false;
    //ShareCare
    if(this.userSession.isDataLoaded){
      //checking for share care unsecured flow login
      var isShareCareLogin = this.userSession.getSession('isShareCareLogin');
    }
    if (!this.userSession.isDataLoaded) {     
      //Deleting cookie for accountId only for solving the cookies issue
      this.userSession.deleteCookie('accountId');
      //console.log('saving deeplink URL: ' + state.url);
      // save the deeplink url, we will update necessary code to save additional information such as router data/parameter later.
      // Only save it for the first time, because if user has not logged in, it will remember the first place, but will overwrite after login.
      if (!this.userSession.deeplinkUrl) {
        this.userSession.deeplinkUrl = state.url;
      }

      // this is an transient routing only used for addressing the holistic profile data loading, so don't change url at all
      this.router.navigateByUrl('/fetchUserData', { skipLocationChange: true });
      return false;

      
    }
    else if( isShareCareLogin && isShareCareLogin == 'true' && state.url == '/sharecareSSO'){
      return true;
      //share care unsecured flow routing
    }
    else if (this.userSession.getLocalStorageItem('isMfaFlow') == "Yes") {
      //console.log("isMFAFlow is true");      
      this.router.navigateByUrl('/mfa');
      return false;
      // Step up auth check below. This is a front-end security implementation to force user to answer security questions
      // before allowing them to view secured pages.
    } 
    // else if (
    //   // feature flag for need step up auth is present
    //   this.userSession.getMemberFeatureFlags().needStepUpAuth &&
    //   // and user has not already completed the step up auth
    //   this.userSession.getLocalStorageItem('needStepUpAuth') !== "true" &&
    //   // and user is not currently navigating to step up auth
    //   state.url !== '/selfService/stepUpAuth' &&
    //   this.userSession.getMemberAttributes().multiFactorConsent!=='EN' && this.userSession.getMemberAttributes().multiFactorConsent!=='Y' &&
    //   this.userSession.getLocalStorageItem('MFAMember') !== 'Yes' && !this.userSession.getMemberProfile().impersonation


    // ) {
    //   // then go to step up auth page
    //   this.router.navigateByUrl('/selfService/stepUpAuth');
    //   return true;
    // }
    else if(this.userSession.getLocalStorageItem('needStepUpAuth') === "true" && this.userSession.getMemberFeatureFlags().needStepUpAuth){
      if(// feature flag for need step up global consent is present
        this.userSession.getMemberFeatureFlags().needGlobalConsent &&
        // member profile for need step member should not be Ebiz user
        !this.userSession.getMemberProfile().impersonation &&
        (isShareCareLogin == "false" || !isShareCareLogin) &&
        this.userSession.getLocalStorageItem('needGlobalConsent') == "false" 
        && state.url !== '/econsent/globleconsentonly'      
        ){
          this.router.navigateByUrl('/econsent/globleconsentonly');        
          return true;
      }
      return true;
    }
      else if(
      // feature flag for need step up global consent is present
      this.userSession.getMemberFeatureFlags().needGlobalConsent &&
      // member profile for need step member should not be Ebiz user
      !this.userSession.getMemberProfile().impersonation &&
      (isShareCareLogin == "false" || !isShareCareLogin) &&
      this.userSession.getLocalStorageItem('needGlobalConsent') == "false" &&
       // and user is not currently navigating to step up E Consent page
      state.url !== '/econsent/globleconsentonly'  &&
      (this.userSession.getLocalStorageItem('needStepUpAuth') == "true" || !this.userSession.getMemberFeatureFlags().needStepUpAuth)
    ){
        // then go to E consent page
        this.router.navigateByUrl('/econsent/globleconsentonly');      
        return true;     
    }
    // Removing the condition for 2FA as flag is enabled for house account members
    // else if(this.userSession.promptAccountRecoveryPromo() && !this.userSession.hasPromoPageTaken() && !this.userSession.getMemberProfile().impersonation){
    //   this.userSession.promoPageTaken = true;
    //   this.router.navigateByUrl('/emailTextPromo/home');
    // }     
    else {
      this.userSession.promoPageTaken = false;
      return true;
    }
   
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.guard.ts